// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-d87f8ce4] .el-table th.el-table__cell.is-leaf{border-bottom:none!important}.addBtn[data-v-d87f8ce4]{background:#2468f2;border-color:#2468f2;padding:0 20px}.addBtn[data-v-d87f8ce4]:hover{background:rgba(36,105,242,.8392156862745098);border-color:rgba(36,105,242,.8392156862745098)}[data-v-d87f8ce4] .el-icon-close{font-size:18px}", ""]);
// Exports
module.exports = exports;
